import { badgeTemplate as fastBadgeTemplate } from '@microsoft/fast-foundation';
export const foundationBadgeTemplate = (context, definition) => fastBadgeTemplate(context, definition);
